import { Stack } from "@altimateai/lego";
import {
  IconCircleCheckFilled,
  IconCircleXFilled,
  IconBellRingingFilled,
  IconCircleMinus,
  IconClockFilled,
} from "@tabler/icons-react";
import { RunStatus } from "@/pages/subscriptions/constants";

interface RunStatusIconProps {
  status: RunStatus | string;
  alertTriggered?: boolean;
}

export const RunStatusIcon = ({ status, alertTriggered }: RunStatusIconProps) => {
  if (status === RunStatus.TRIGGERED || alertTriggered) {
    return (
      <Stack direction="row" align="center" justify="center" className="al-w-6 al-h-6">
        <IconBellRingingFilled className="al-fill-chip-green" />
      </Stack>
    );
  }

  if (status === RunStatus.SENT) {
    return (
      <Stack
        direction="row"
        align="center"
        justify="center"
        className="al-w-6 al-h-6 al-rounded-full"
      >
        <IconCircleCheckFilled className="al-fill-chip-green" />
      </Stack>
    );
  }

  if (status === RunStatus.FAILURE) {
    return (
      <Stack
        direction="row"
        align="center"
        justify="center"
        className="al-w-6 al-h-6 al-rounded-full"
      >
        <IconCircleXFilled className="al-text-gray-400" />
      </Stack>
    );
  }

  // Alert condition not met — distinct from "no run yet" / placeholder slots.
  if (status === RunStatus.SKIPPED) {
    return (
      <Stack
        direction="row"
        align="center"
        justify="center"
        className="al-w-6 al-h-6 al-rounded-full al-bg-gray-100"
      >
        <IconCircleMinus className="al-text-gray-400" />
      </Stack>
    );
  }

  // Placeholder / pending / unknown — clock keeps it visually distinct
  // from a real SKIPPED row in the recent-runs sparkline.
  return (
    <Stack
      direction="row"
      align="center"
      justify="center"
      className="al-w-6 al-h-6 al-rounded-full al-bg-gray-100"
    >
      <IconClockFilled className="al-text-gray-300" />
    </Stack>
  );
};
